import 'lodash';
import { Quill } from 'react-quill';

const Link = Quill.import('formats/link');

Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto'];

function isEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

class CustomLinkSanitizer extends Link {
  static sanitize(url) {
    const sanitizedUrl = super.sanitize(url);
    if (!sanitizedUrl || sanitizedUrl === 'about:blank') return sanitizedUrl;

    const hasWhitelistedProtocol = this.PROTOCOL_WHITELIST.some(function (protocol) {
      return sanitizedUrl.startsWith(protocol);
    });

    if (hasWhitelistedProtocol) return sanitizedUrl;

    if (isEmail(sanitizedUrl)) return `mailto:${sanitizedUrl}`;

    if (sanitizedUrl.startsWith('###')) return sanitizedUrl;

    return `https://${sanitizedUrl}`;
  }
}

Quill.register(CustomLinkSanitizer, true);
